// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "title-2QcXx";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "title" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "title": _4 }
